import React from 'react';
import { motion } from 'framer-motion';
interface CyberButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
}
export function CyberButton({
  variant = 'primary',
  children,
  className = '',
  ...props
}: CyberButtonProps) {
  const baseStyles = 'relative group px-8 py-4 font-cyber font-bold tracking-widest uppercase transition-all duration-300 overflow-hidden';
  const variants = {
    primary: 'text-cyan hover:text-black hover:bg-cyan hover:shadow-[0_0_20px_rgba(0,212,255,0.5)]',
    secondary: 'text-magenta hover:text-white hover:bg-magenta/20 hover:shadow-[0_0_30px_rgba(255,0,255,0.5)]'
  };
  const borderColor = variant === 'primary' ? 'border-cyan' : 'border-magenta';
  const bgColor = variant === 'primary' ? 'bg-cyan/10' : 'bg-transparent';
  // The clip-path polygon that cuts Top-Left and Bottom-Right corners
  const clipPath = 'polygon(20px 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%, 0 20px)';
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} style={{
    clipPath
  }} {...props} data-id="element-121">
      {/* Single unified border and background layer */}
      <div className={`absolute inset-0 border ${borderColor} ${bgColor} transition-all duration-300 ${variant === 'secondary' ? 'group-hover:border-magenta' : 'group-hover:border-transparent'}`} style={{
      clipPath
    }} data-id="element-122" />

      {/* Content */}
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-123">
        {children}
      </span>
    </button>;
}